import { render, staticRenderFns } from "./ReceivershipTask.vue?vue&type=template&id=a00bf1a2&scoped=true&"
import script from "./ReceivershipTask.vue?vue&type=script&lang=js&"
export * from "./ReceivershipTask.vue?vue&type=script&lang=js&"
import style0 from "./ReceivershipTask.vue?vue&type=style&index=0&id=a00bf1a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00bf1a2",
  null
  
)

export default component.exports